import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { LoaderService } from '../../services';
import { LoaderState } from '../../models/loader.model';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit, OnDestroy {
    show = false;
    private subscription: Subscription;
    constructor(private loaderService: LoaderService) { }

    ngOnInit() {
        this.subscription = this.loaderService.loaderState.subscribe((state: LoaderState) => {
           this.show = state.show;
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/components/loading/loading.component.ts